import Request from './request'

const ClientRequestSimcard  = {
  getClientRequestSimcardList(params, callback) {
    Request.get('client-request-simcard/index', params).then(callback).catch(this.bad_answer)
  },
}

export default ClientRequestSimcard
